module.exports = "<svg preserveAspectRatio=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 738 119\">\n   <g id=\"Page-1\" stroke=\"none\" stroke-  fill-rule=\"evenodd\">\n         <path  d=\"M0,0 C0,0 254.075521,87 369,87 C483.924479,87 738,0 738,0 L738,119 L0,119 L0,0 Z\" id=\"Rectangle\" ></path>\n    </g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/curve.svg
// module id = 2778
// module chunks = 0